"use strict";

var _root;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unifiPalette = void 0;

var styles_1 = require("@material-ui/core/styles");

var lodash_1 = require("lodash");

var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");

var materialTheme_1 = __importDefault(require("./materialTheme"));

var index_1 = require("../util/index");

var parentTheme = styles_1.createMuiTheme(materialTheme_1.default);
var colorPrimary = '#107F1B';
var colorPrimaryLight = '#AED136';
var colorSecondary = '#0E729A';
var colorSecondaryLight = '#0AA0BE';
var colorWarning = '#EE6B18';
var colorInfo = colorSecondaryLight;
var colorSuccess = '#55A43A';
var colorError = '#C80600';
var colorUiFocus = '#2765d9';
var colorHref = colorSecondary;
var colorHrefVisited = '#8963af';
exports.unifiPalette = {
  primary: {
    main: colorPrimary,
    light: colorPrimaryLight
  },
  secondary: {
    main: colorSecondary,
    light: colorSecondaryLight
  },
  error: {
    main: colorError
  },
  warning: {
    main: colorWarning
  },
  info: {
    main: colorInfo
  },
  success: {
    main: colorSuccess
  }
};
var linkStates = {
  '& a': {
    color: colorHref,
    textDecoration: 'underline'
  },
  '& a:hover': {
    textDecoration: 'none'
  },
  '& a:visited': {
    color: colorHrefVisited,
    textDecoration: 'none'
  }
};
var baseThemeOptions = {
  themeName: 'Unifi',
  palette: Object.assign({}, exports.unifiPalette),
  typography: {
    fontFamily: ['"Open Sans"', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(','),
    fontSize: 16,
    h1: {
      fontSize: '3.75rem',
      letterSpacing: '-.015em',
      lineHeight: '1.15'
    },
    h2: {
      fontSize: '2.125rem',
      fontWeight: 400,
      letterSpacing: '-.01em',
      lineHeight: '1.15'
    },
    h3: {
      fontSize: '1.5rem',
      lineHeight: '1.15'
    },
    h4: {
      fontSize: '1.25rem'
    },
    h5: {
      fontSize: '1.125rem'
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 400
    },
    body1: {
      fontSize: '1.125rem',
      lineHeight: '1.5',
      letterSpacing: '0'
    },
    body2: {
      fontSize: '1rem',
      lineHeight: '1.5',
      letterSpacing: '0'
    },
    subtitle1: {
      fontSize: '1.5rem',
      lineHeight: '1.5'
    },
    subtitle2: {
      fontSize: '.9rem'
    },
    caption: {
      fontSize: '.9rem',
      letterSpacing: '0.03em'
    },
    overline: {
      fontSize: '.9rem',
      lineHeight: '1.4',
      letterSpacing: '.17em'
    },
    button: {
      fontWeight: 400,
      letterSpacing: '0.1em'
    }
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '*': Object.assign({}, index_1.boxSpacing)
      }
    },
    MuiPaper: {
      outlined: {
        borderColor: colorManipulator_1.fade('#000', 0.42)
      }
    },
    MuiAvatar: {
      colorDefault: {
        backgroundColor: '#919191'
      }
    },
    MuiButton: {
      root: {
        letterSpacing: '0.1em',
        padding: parentTheme.spacing(1) + "px " + parentTheme.spacing(2) + "px"
      },
      contained: {
        '&:focus': {
          boxShadow: '0 0 0 4px #949494'
        }
      },
      containedPrimary: {
        '&:focus': {
          boxShadow: "0 0 0 4px " + colorManipulator_1.darken(colorPrimary, 0.4)
        }
      },
      containedSecondary: {
        '&:focus': {
          boxShadow: "0 0 0 4px " + colorManipulator_1.darken(colorSecondary, 0.4)
        }
      },
      outlined: {
        borderColor: colorManipulator_1.fade('#000', 0.54),
        '&:focus': {
          boxShadow: '0 0 0 2px currentColor'
        },
        '&$disabled:hover': {
          borderColor: 'inherit'
        }
      },
      text: {
        '&:focus': {
          boxShadow: '0 0 0 2px currentColor'
        }
      }
    },
    MuiButtonBase: {
      root: {
        '&$disabled': {
          cursor: 'not-allowed',
          pointerEvents: 'initial'
        }
      }
    },
    MuiButtonGroup: {
      grouped: {
        '&[class*="sizeSmall"]': {
          padding: parentTheme.spacing(0.5) + "px " + parentTheme.spacing(1.5) + "px"
        }
      }
    },
    MuiCardActions: {
      root: (_root = {
        paddingBottom: parentTheme.spacing(2) + "px"
      }, _root[parentTheme.breakpoints.up('sm')] = {
        paddingBottom: parentTheme.spacing(2) + "px"
      }, _root)
    },
    MuiCheckbox: {
      root: {
        '&.Mui-focusVisible': {
          '& span:first-child': {
            position: 'relative'
          },
          '& span:first-child:before': {
            content: "''",
            position: 'absolute',
            top: '2px',
            right: '2px',
            bottom: '2px',
            left: '2px',
            boxShadow: "0 0 3px 2px " + colorUiFocus,
            borderRadius: '2px'
          }
        }
      }
    },
    MuiDialogActions: {
      root: {
        padding: "0 " + parentTheme.spacing(2) + "px " + parentTheme.spacing(2) + "px"
      }
    },
    MuiDialogContent: {
      root: {
        paddingBottom: parentTheme.spacing(3) + "px"
      }
    },
    MuiFab: {
      root: {
        '&:focus': {
          boxShadow: '0 0 0 4px #949494'
        }
      },
      primary: {
        '&:focus': {
          boxShadow: "0 0 0 4px " + colorManipulator_1.darken(colorPrimary, 0.4)
        }
      },
      secondary: {
        '&:focus': {
          boxShadow: "0 0 0 4px " + colorManipulator_1.darken(colorSecondary, 0.4)
        }
      }
    },
    MuiIconButton: {
      root: {
        border: '1px solid transparent',
        '&:focus': {
          borderColor: 'currentColor'
        }
      }
    },
    MuiInputBase: {
      root: {
        lineHeight: '1.18em',
        '&$disabled, & input:disabled': {
          cursor: 'not-allowed',
          pointerEvents: 'initial'
        }
      }
    },
    MuiInput: {
      root: {
        '&$underline:before': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.5)'
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: 'rgba(0, 0, 0, 0.56)'
      }
    },
    MuiLink: {
      root: {
        fontFamily: ['"Open Sans"', '-apple-system', 'BlinkMacSystemFont', '"Segoe UI"', 'Roboto', '"Helvetica Neue"', 'Arial', 'sans-serif', '"Apple Color Emoji"', '"Segoe UI Emoji"', '"Segoe UI Symbol"'].join(',')
      },
      underlineAlways: {
        '&:hover': {
          textDecoration: 'none'
        }
      }
    },
    MuiList: {
      root: {
        backgroundColor: parentTheme.palette.background.paper,
        flexGrow: 1,
        flexBasis: '100%'
      }
    },
    MuiListItem: {
      root: {
        flexWrap: 'wrap',
        '& > a': {
          color: 'inherit',
          margin: 'inherit',
          paddingLeft: '16px',
          paddingRight: '16px',
          textDecoration: 'none',
          width: '100%',
          display: 'flex',
          position: 'relative',
          flexWrap: 'wrap',
          boxSizing: 'border-box',
          textAlign: 'left',
          alignItems: 'center',
          justifyContent: 'flex-start',
          '&:hover': {
            backgroundColor: parentTheme.palette.grey[100]
          }
        }
      }
    },
    MuiMenuItem: {
      root: {
        fontSize: '1.125rem',
        '&:hover': {
          backgroundColor: parentTheme.palette.grey[200],
          cursor: 'pointer'
        },
        '&$selected': {
          color: '#fff !important',
          backgroundColor: colorUiFocus + " !important"
        },
        '&$selected span': {
          color: '#fff'
        },
        '&:focus': {
          position: 'relative',
          outline: 'none'
        },
        '&:focus::before': {
          content: '""',
          position: 'absolute',
          left: '0',
          top: '50%',
          marginTop: '-4px',
          width: 0,
          height: 0,
          borderLeft: '8px solid currentColor',
          borderTop: '8px solid transparent',
          borderBottom: '8px solid transparent'
        }
      }
    },
    MuiOutlinedInput: {
      notchedOutline: {
        borderColor: colorManipulator_1.fade('#000', 0.42)
      }
    },
    MuiRadio: {
      root: {
        '&.Mui-focusVisible': {
          '& span:first-child': {
            position: 'relative'
          },
          '& span:first-child:before': {
            content: "''",
            position: 'absolute',
            top: '.08rem',
            right: '.08rem',
            bottom: '.08rem',
            left: '.08rem',
            boxShadow: "0 0 3px 2px " + colorUiFocus,
            borderRadius: '50%'
          }
        }
      }
    },
    MuiSelect: {
      root: {
        '&$disabled, &$disabled > div, &$disabled > select': {
          cursor: 'not-allowed !important',
          pointerEvents: 'initial'
        }
      },
      selectMenu: {
        minHeight: 'auto'
      },
      outlined: {
        '&:focus': {
          backgroundColor: 'transparent'
        }
      }
    },
    MuiSwitch: {
      root: {
        '& .Mui-focusVisible [class*="MuiSwitch-thumb"]': {
          position: 'relative',
          '&::before': {
            content: "''",
            position: 'absolute',
            top: '-2px',
            right: '-2px',
            bottom: '-2px',
            left: '-2px',
            boxShadow: "0 0 0 0.07em transparent, 0 0 3px 3px " + colorUiFocus,
            borderRadius: '50%'
          }
        }
      },
      thumb: {
        boxShadow: '0px 1px 3px 1px rgba(0,0,0,0.6), 0px -1px 1px 0px rgba(0,0,0,0.67), 0px -2px 0px -2px rgba(0,0,0,0.18)'
      },
      track: {
        opacity: 0.42
      }
    },
    MuiSvgIcon: {
      root: {
        fontSize: '24px'
      }
    },
    MuiTab: {
      root: {
        '&:focus > span': {
          position: 'relative'
        },
        '&:focus > span:after': {
          content: '""',
          position: 'absolute',
          left: '50%',
          marginLeft: '-3px',
          bottom: '-2px',
          width: 0,
          height: 0,
          borderLeft: '6px solid transparent',
          borderRight: '6px solid transparent',
          borderBottom: '6px solid currentColor'
        }
      }
    },
    MuiTableCell: {
      root: {
        fontSize: '.875rem',
        '&.TableCell-hideBorders': {
          borderColor: 'transparent',
          verticalAlign: 'top'
        }
      },
      head: {
        fontWeight: 600,
        color: 'rgba(0, 0, 0, 0.87)',
        lineHeight: 1.375,
        whiteSpace: 'nowrap'
      },
      sizeSmall: {
        paddingLeft: '8px',
        lineHeight: 1.3
      }
    },
    MuiTableRow: {
      hover: {
        cursor: 'pointer'
      }
    },
    MuiTextField: {
      root: {
        '&.Mui-readonly div:after, &.Mui-readonly div:before': {
          borderBottom: '1px dashed rgba(0, 0, 0, 0.23)',
          transform: 'none'
        },
        '&.Mui-readonly div.Mui-focused:after': {
          borderBottom: '1px solid rgba(0, 0, 0, 0.54)'
        },
        '&.Mui-readonly input, &.Mui-readonly textarea': {
          '& + fieldset': {
            borderStyle: 'dashed',
            borderColor: colorManipulator_1.fade('#000', 0.42)
          },
          '&::selection': {
            backgroundColor: 'rgba(0,0,0,0.08)'
          },
          '&:hover, &:focus': {
            cursor: 'not-allowed',
            pointerEvents: 'initial',
            '& + fieldset': {
              borderColor: colorManipulator_1.fade('#000', 0.42),
              borderWidth: '1px',
              borderStyle: 'solid'
            }
          }
        },
        '&.Mui-focused.Mui-readonly input, &.Mui-focused.Mui-readonly textarea': {
          '& + fieldset': {
            borderColor: colorManipulator_1.fade('#000', 0.42),
            borderWidth: '1px',
            borderStyle: 'solid'
          }
        }
      }
    },
    MuiTypography: {
      paragraph: Object.assign({}, linkStates)
    }
  }
};
var unifiBaseTheme = lodash_1.merge({}, materialTheme_1.default, baseThemeOptions);
exports.default = unifiBaseTheme;